import { Action, createReducer, on } from '@ngrx/store';
import * as contactActions from '../action/contact.action';
import { ContactResponseModel } from '../model/contact-response.model';
import { ContactModel } from '../model/contact.model';

export interface ContactState {
    contact: ContactModel,
    response: ContactResponseModel,
    isUploading: boolean,
    isUploadingSuccess: boolean,
    isUploadingFailure: boolean
}

export const initialState: ContactState = {
    contact: {} as ContactModel,
    response: {} as ContactResponseModel,
    isUploading: false,
    isUploadingSuccess: false,
    isUploadingFailure: false
};

const contactReducer = createReducer(
    initialState,
    on(contactActions.contact, (state, contact) =>
    ({
        contact,
        isUploading: true,
        isUploadingFailure: false,
        isUploadingSuccess: false,
        response: {} as ContactResponseModel
    })),
    on(contactActions.contactReset, (state, contact) =>
    ({
        contact: {} as ContactModel,
        isUploading: false,
        isUploadingFailure: false,
        isUploadingSuccess: false,
        response: {} as ContactResponseModel
    })),
    on(contactActions.contactSuccess, (state, response) =>
    ({
        contact: state.contact,
        isUploading: false,
        isUploadingFailure: false,
        isUploadingSuccess: true,
        response
    })),
    on(contactActions.contactFailure, (state, response) =>
    ({
        contact: state.contact,
        isUploading: false,
        isUploadingFailure: true,
        isUploadingSuccess: false,
        response
    }))
)

export function reducer(
    state: ContactState | undefined,
    action: Action
): ContactState {
    return contactReducer(state, action);
}
